'use client';
import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/app/utils';
import { HeadlessImageUploader, type HeadlessImageUploaderProps } from './HeadlessImageUploader';

export type { HeadlessImageUploaderProps, ImageUploaderRenderApi } from './HeadlessImageUploader';
export { HeadlessImageUploader } from './HeadlessImageUploader';

export interface ImageUploaderProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange' | 'children'>,
    HeadlessImageUploaderProps {
  className?: string;
  children?: ReactNode;
}

/**
 * 图片上传组件
 *
 * 默认仅点击触发文件选择器（click-only），通过传入 children 自定义按钮样式。
 */
export const ImageUploader = forwardRef<HTMLInputElement, ImageUploaderProps>(
  (
    {
      className,
      maxCount = 1,
      disabled,
      maxFileSize,
      isInitialSelectedImageRange = true,
      scene,
      getSelectedImage,
      onChange,
      allowTempMode = false,
      emitUploadingInTempMode = true,
      validateImageResolution,
      children,
      imageAccept,
      dialogTheme,
      ...rest
    },
    ref,
  ) => {
    return (
      <HeadlessImageUploader
        ref={ref}
        maxCount={maxCount}
        disabled={disabled}
        maxFileSize={maxFileSize}
        isInitialSelectedImageRange={isInitialSelectedImageRange}
        scene={scene}
        getSelectedImage={getSelectedImage}
        onChange={onChange}
        allowTempMode={allowTempMode}
        emitUploadingInTempMode={emitUploadingInTempMode}
        validateImageResolution={validateImageResolution}
        imageAccept={imageAccept}
        dialogTheme={dialogTheme}
      >
        {(api) => (
          <div className={cn('cursor-pointer', className)} onClick={api.openFileSelector} {...rest}>
            {children}
          </div>
        )}
      </HeadlessImageUploader>
    );
  },
);

ImageUploader.displayName = 'ImageUploader';
